import React from 'react'
import { Box, Typography, Pill } from 'components'
import { makeStyles, Chip } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  disabilityChip: {
    margin: theme.spacing(0.5),
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    '& .MuiChip-label': {
      fontSize: '0.85rem',
      fontWeight: 400
    }
  },
  sectionContainer: {
    backgroundColor: 'white',
    border: '1px solid #DDD',
    borderRadius: 10,
    marginBottom: theme.spacing(3)
  }
}))

export default function FreelancerDisabilitySection({ freelancer, onEdit: propOnEdit }) {
  const classes = useStyles()
  const history = useHistory()

  // If onEdit is provided as a prop, use it. Otherwise, redirect to disability edit route
  const onEdit = propOnEdit

  // Only render if there are disability tags or specifically showing the section for editing
  if ((!freelancer.disabilityStatus || freelancer.disabilityStatus === 'No' || freelancer.disabilityStatus === 'Prefer not to answer') &&
    (!freelancer.selectedDisabilities || freelancer.selectedDisabilities.length === 0) &&
    !onEdit) {
    return null
  }

  return (
    <Box className={classes.sectionContainer}>
      <Box flex={1} pt={3.5} px={3.5} pb={2}>
        <Box flex={1} flexVariant="row space-between" mb={2.5}>
          <Typography variant="h4" style={{ fontWeight: '600' }}>
            Accessibility
          </Typography>
          {onEdit &&
            <Pill size="small" onClick={onEdit}>
              Manage Information
            </Pill>}
        </Box>

        <Box display="flex" flexWrap="wrap" mb={2}>
          {/* Always show the main disability tag if status is Yes */}
          {freelancer.disabilityStatus === 'Yes' && (
            <Chip
              key="disability-main"
              label="A person with a disability"
              className={classes.disabilityChip}
            />
          )}

          {/* Show specific disabilities if any are selected */}
          {freelancer.selectedDisabilities && freelancer.selectedDisabilities.map((disability, index) => {
            // Skip the "prefer not to answer" options in display
            if (disability === 'I prefer not to answer' || disability === 'None of the above describes how I identify') {
              return null;
            }
            return (
              <Chip
                key={`disability-${index}`}
                label={disability}
                className={classes.disabilityChip}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  )
}
